import React, { useEffect } from "react";
import { BsCreditCard } from "react-icons/bs";
import "../assets/css/north.css"
import NorthImg from "../assets/north-img.png";
import NorthImg1 from "../assets/north-1.jpg";
import hero1 from "../assets/TIG Website Images/Our Businesses/Northstar/d.png";
import AOS from "aos";
import "aos/dist/aos.css";

export default function NorthStar() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid p-0">
        <div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <p className="text-uppercase text-light m-0">INTEGRITY & GROWTH</p>
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                NorthStar Financial Consultancy
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Section 1: NorthStar at a Glance */}
      <div data-aos="fade-up">
        <div className="container mt-5">
          <div className="row align-items-center">
            {/* Image */}
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={NorthImg}
                alt="Northstar"
                className="section-image img-fluid rounded"
              />
            </div>

            {/* Text Content */}
            <div className="section-text col-md-6">
              <h2 className="mb-3 fw-bold">NORTHSTAR AT A GLANCE</h2>
              <p className="fs-5">
                NorthStar Recovery Service is a part of Towers International Group of Companies, established in 1999 as an Omani-owned SME. With deep roots in the Muscat region of Oman, the company was founded by Mr. Ahmed Qadir Al Balushi, a former banker with over 27 years of experience in Oman’s banking sector.
                NorthStar is widely recognized for its strong leadership and unwavering commitment to quality. Our emphasis on effective follow-up and debt collection has positioned us as a leader in the field, earning the trust and confidence of our clients.
              </p>
              <a
                href="#!"
                className="text-primary text-decoration-none fs-5"
                style={{ fontWeight: 600 }}
              >
                Read More →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Features */}
      <section className="py-5 bg-white" id="features" data-aos="fade-up">
        <div className="container text-center">
          <span className="feature-badge badge rounded-pill bg-light text-primary px-3 py-2 mb-2 border border-primary fs-6">
            • Features
          </span>

          <h2 className="fw-bold display-6 mb-3">
            NorthStar Recovery Services – <br />
            Features That Set Us Apart
          </h2>
          <p className="text-muted mb-5 fs-5">
            Delivering trusted debt recovery with professionalism, precision,
            and proven experience.
          </p>

          <div className="row g-4">
            {[
              {
                title: "Proven Leadership",
                desc: "Founded by a seasoned ex-banker with 27+ years of experience in Oman's financial sector.",
              },
              {
                title: "Strong Local Presence",
                desc: "Deep connections in the Muscat region, building trust across Oman.",
              },
              {
                title: "Specialized Debt Collection",
                desc: "Focused expertise in follow-up and efficient recovery of dues.",
              },
              {
                title: "Client-Centric Approach",
                desc: "Tailored services with high attention to client confidence and satisfaction.",
              },
              {
                title: "Commitment to Quality",
                desc: "Consistent, reliable service with attention to detail in every engagement.",
              },
              {
                title: "Trusted SME Heritage",
                desc: "Part of an Omani-owned SME group established in 1999.",
              },
            ].map((item, index) => (
              <div className="col-md-4" key={index}>
                <div className="feature-card h-100 rounded-5">
                  <div className="d-flex justify-content-center mb-4">
                    <div className="icon-circle-north rounded-circle text-white d-flex align-items-center justify-content-center">
                      <BsCreditCard size={24} color="#fff" />
                    </div>
                  </div>
                  <h5 className="feature-title fw-semibold text-center mb-3">
                    {item.title}
                  </h5>
                  <p className="feature-desc text-muted text-center">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: Trusted Collections */}
      <section className="trusted-collections-section py-3 py-md-5 bg-white" data-aos="fade-up">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-lg-6 col-md-12 text-center">
              <img
                src={NorthImg1}
                alt="Trusted Collections"
                className="trusted-image img-fluid"
                style={{height:'600px'}}
              />
            </div>

            {/* Right Content */}
            <div className="col-lg-6 trusted-content">
              <span className="feature-badge badge mt-4 mt-md-0 rounded-pill bg-light text-primary px-3 py-2 mb-2 border border-primary fs-6">
                • Trusted Collections
              </span>

              <p className="trusted-title display-6 mb-3">
                Our debt recovery <br />
                process is built on trust, <br />
                quality, and experience.
              </p>

              <p className="trusted-description text-muted mb-4 fs-5">
                Its structured approach ensures businesses and institutions can
                recover their dues efficiently — backed by a highly experienced
                leadership and a commitment to results.
              </p>

              <div className="row g-3">
                {[
                  {
                    icon: "fa-shield-alt",
                    text: "Confidential and respectful collection process.",
                  },
                  {
                    icon: "fa-lightbulb",
                    text: "Custom strategies for better results.",
                  },
                  {
                    icon: "fa-piggy-bank",
                    text: "27+ years of trusted banking experience.",
                  },
                  {
                    icon: "fa-map-marker-alt",
                    text: "Strong roots in the Muscat region.",
                  },
                ].map((item, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    <div className="trusted-feature d-flex rounded-4 p-3 h-100">
                      <div className="trusted-icon text-white rounded-2 p-2 me-3 d-flex align-items-center justify-content-center">
                        <i className={`fas ${item.icon}`}></i>
                      </div>
                      <span className="text-dark fw-semibold trusted-feature-text">
                        {item.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
